<template>
	<div>
		<ts-loading-banner :loading="loading">
			<form class="form-horizontal">
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.setupDate')
					}}</label>
					<div class="col-md-6">
						<ts-date-picker-input v-model="model.setup_date">
						</ts-date-picker-input>
					</div>
					<div class="invalid-feedback" v-if="errors.has('setup_date')">
						{{ errors.first('setup_date') }}
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.portfolioType')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.portfolio_type_id" style="width: 100%" :options="portfolios" :show-search="true"
							option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
						<div class="invalid-feedback" v-if="errors.has('portfolio_type_id')">
							{{ errors.first('portfolio_type_id') }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.acYear')
					}}</label>
					<div class="col-md-6">
						<input type="text" class="form-control" readonly :value="acYearLabel" />
						<div class="invalid-feedback" v-if="errors.has('ac_year_id')">
							{{ errors.first('ac_year_id') }}
						</div>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.academicTerm')
					}}</label>
					<div class="col-md-6">
						<input type="text" class="form-control" readonly :value="acTermLabel" />
					</div>
				</div>
				<div class="row">
					<label class="col-form-label col-md-4"></label>
					<div class="col-md-6">
						<a-radio-group v-model="acStatusId" @change="onStatusChange" size="small">
							<a-radio-button :value="1">
								{{ $t('portfolioPhoto.current') }}
							</a-radio-button>
							<a-radio-button :value="2">
								{{ $t('portfolioPhoto.history') }}
							</a-radio-button>
						</a-radio-group>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4 required">{{
						$t('portfolioPhoto.className')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.class_id" style="width: 100%" :options="classList" @change="onClassChange"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
					</div>
				</div>
				<div class="row form-group">
					<label class="col-form-label col-md-4">{{
						$t('portfolioPhoto.studentName')
					}}</label>
					<div class="col-md-6">
						<a-select v-model="model.student_id" :placeholder="$t('all')" style="width: 100%" :options="student_list"
							:show-search="true" option-filter-prop="children" :filter-option="(input, option) =>
								option.componentOptions.children[0].text
									.toLowerCase()
									.indexOf(input.toLowerCase()) >= 0
								"></a-select>
					</div>
				</div>
				<form class="form-horizontal">
					<fieldset>
						<legend>{{ $t('portfolioPhoto.attachmentFile') }}</legend>
						<AttachFile v-model="model" />
					</fieldset>
				</form>
				<div class="validate" v-if="errors.has('attach_file_list')">
					{{ errors.first('attach_file_list') }}
				</div>
				<div class="row">
					<div class="col-md-12 ts-mt-4 text-right">
						<ts-button class="ts-mr-2" @click.prevent="() => $emit('cancel')">
							{{ $t('cancel') }}
						</ts-button>
						<ts-button v-if="!isUpdate" :disabled="!isAllUploaded || model.attach_file_list.length == 0" color="primary"
							:waiting="waiting" @click.prevent="save">{{
								$t('save') }}</ts-button>
						<ts-button v-if="isUpdate" color="primary" :disabled="!isAllUploaded" :waiting="waiting"
							@click.prevent="onUpdate">{{
								$t('update') }}</ts-button>
					</div>
				</div>
			</form>
		</ts-loading-banner>
	</div>
</template>
  
<script>
import { Errors } from 'form-backend-validation'
import AttachFile from './attach-file.vue'
import moment from 'moment'
import { mapState, mapActions } from 'vuex'
import { isEmpty } from "lodash";
export default {
	name: 'form',
	components: {
		AttachFile
	},
	data() {
		return {
			loading: false,
			waiting: false,
			class_list: [],
			student_list: [],
			terms: [],
			years: [],
			portfolios: [],
			errors: new Errors(),
			model: {
				upload_id: 0,
				student_id: undefined,
				class_id: undefined,
				setup_date: moment().format('DD-MM-YYYY'),
				portfolio_type_id: null,
				term_id: undefined,
				ac_year_id: null,
				attach_file_list: []
			}
		}
	},
	computed: {
		...mapState("portfolioPhoto", ["edit_data"]),
		isUpdate() {
			return !_.isEmpty(this.edit_data)
		},
		acStatusId: {
			get() {
				return this.$store.state.portfolioPhoto.ac_status_id
			},
			set(newValue) {
				this.$store.commit(
					'portfolioPhoto/SET_AC_STATUS',
					newValue
				)
			}
		},
		classList() {
			return this.class_list.map(el => ({
				value: el.class_id,
				label: el.class_name,
				ac_year_id: el.ac_year_id,
				term_id: el.ac_term_id
			}))
		},
		acYearLabel() {
			return this.class_list
				.filter(c => c.class_id == this.model.class_id)
				.reduce((init, item) => (init = item.academic_year.ac_year), null)
		},
		acTermLabel() {
			return this.class_list
				.filter(c => c.class_id == this.model.class_id)
				.reduce((init, item) => (init = item.academic_term.term_name), null)
		},
		isAllUploaded() {
			const allFiles = this.model.attach_file_list.length

			const uploadedFile = this.model.attach_file_list.filter(u => u.uploaded === true)

			return allFiles == uploadedFile.length
		}
	},
	created() {
		this.fetchClass()
		this.fetchPortfolio()
		this.setEditData()
	},
	methods: {
		...mapActions('portfolioPhoto', ['getClassOperation']),
		onStatusChange() {
			this.class_list = []
			this.model.class_id = null
			this.model.ac_year_id = null
			this.model.term_id = null
			this.model.student_id = null
			this.fetchClass()
		},
		fetchClass() {
			this.loading = true
			this.getClassOperation({ branch_id: this.$store.state.authUser.default_branch_id })
				.then(response => {
					this.class_list = response.data
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		onClassChange(value, option) {
			this.model.ac_year_id = option.data.props.ac_year_id
			this.model.term_id = option.data.props.term_id
			this.term_order = option.data.props.term_order
			this.student_list = []
			this.model.student_id = undefined
			this.fetchStudent()
		},
		fetchStudent() {
			this.loading = true
			this.$store
				.dispatch(
					'portfolioPhoto/getStudentEnrollmentByClass', Object.assign({
						class_id: this.model.class_id,
						branch_id: this.$store.state.authUser.default_branch_id
					})
				)
				.then(response => {
					this.student_list = response.data
						.filter(e => e.student_profile != null)
						.map(el => ({
							value: el.student_profile.student_id,
							label:
								el.student_profile.card_number +
								'|' +
								el.student_profile.full_name_en
						}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		fetchPortfolio() {
			this.$store
				.dispatch('portfolioPhoto/getPortfolio')
				.then(response => {
					this.portfolios = response.data.map(el => ({
						value: el.portfolio_type_id,
						label: el.portfolio_name_en
					}))
				})
				.catch(error => {
					this.$toasted.error(error.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
		save() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('portfolioPhoto/store', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.$emit('fetchData')
					this.$emit('cancel')
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		onUpdate() {
			this.errors = new Errors()
			this.waiting = true
			this.$store
				.dispatch('portfolioPhoto/update', this.model)
				.then(response => {
					this.$toasted.success(response.message)
					this.$emit('fetchData')
					this.$emit('cancel')
				})
				.catch(error => {
					this.$toasted.error(error.message)
					this.errors = new Errors(error.errors)
				})
				.finally(() => {
					this.waiting = false
				})
		},
		setEditData() {
			if (!isEmpty(this.edit_data)) {
				this.model.upload_id = this.edit_data.upload_id
				this.model.portfolio_type_id = this.edit_data.portfolio_type_id
				this.model.ac_year_id = this.edit_data.ac_year_id
				this.model.term_id = this.edit_data.term_id
				this.model.class_id = this.edit_data.class_id
				this.model.student_id = this.edit_data.student_id ? this.edit_data.student_id : undefined
				this.model.setup_date = this.edit_data.setup_date
				this.fetchStudent()
				this.model.attach_file_list = this.edit_data.gallery_photos.map(el => ({
					file_path: el.file_path,
					file_path: el.storage_path,
					original_file_name: el.original_file_name,
					remarks: el.remarks
				}))
			}
		}
	}
}
</script>

  